"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_STATUS = void 0;
var EVENT_STATUS;
(function (EVENT_STATUS) {
    EVENT_STATUS[EVENT_STATUS["RESERVED"] = 0] = "RESERVED";
    EVENT_STATUS[EVENT_STATUS["BEFORE_PAYMENT"] = 1] = "BEFORE_PAYMENT";
    EVENT_STATUS[EVENT_STATUS["REFUND_REQUEST"] = 2] = "REFUND_REQUEST";
    EVENT_STATUS[EVENT_STATUS["CANCELED_BY_CLIENT"] = 3] = "CANCELED_BY_CLIENT";
    EVENT_STATUS[EVENT_STATUS["CANCELED_BY_CLIENT_BEFORE_DEADLINE"] = 4] = "CANCELED_BY_CLIENT_BEFORE_DEADLINE";
    EVENT_STATUS[EVENT_STATUS["CANCELED_BY_THERAPIST"] = 5] = "CANCELED_BY_THERAPIST";
    EVENT_STATUS[EVENT_STATUS["CANCELED_BY_ADMIN"] = 6] = "CANCELED_BY_ADMIN";
    EVENT_STATUS[EVENT_STATUS["FREE"] = 7] = "FREE";
    EVENT_STATUS[EVENT_STATUS["COMPLETED"] = 8] = "COMPLETED";
    EVENT_STATUS[EVENT_STATUS["PRE_BOOKING"] = 9] = "PRE_BOOKING";
    EVENT_STATUS[EVENT_STATUS["DENIED"] = 10] = "DENIED";
})(EVENT_STATUS || (exports.EVENT_STATUS = EVENT_STATUS = {}));
